export const themeColors = {
  'accent-05': '#F6FCFF',
  'accent-10': '#EDF9FF',
  'accent-20': '#D2EFFF',
  'accent-30': '#A6E0FE',
  'accent-40': '#4DC1FD',
  'accent-50': '#009FF2',
  'accent-60': '#0077C4',
  'accent-70': '#005999',
  'accent-80': '#004C84',
  'accent-90': '#003A64',
  'accent-100': '#002742',
  'neutral-00': '#FFFFFF',
  'neutral-05': '#F9F9F9',
  'neutral-10': '#F0F1F1',
  'neutral-15': '#EAEBEB',
  'neutral-20': '#E4E6E6',
  'neutral-30': '#D2D6D7',
  'neutral-40': '#B7BCBF',
  'neutral-50': '#8C969A',
  'neutral-60': '#6B757A',
  'neutral-70': '#5F696E',
  'neutral-80': '#545D61',
  'neutral-85': '#434B4F',
  'neutral-90': '#383D41',
  'neutral-95': '#2A2E30',
  'neutral-98': '#1C2022',
  'neutral-99': '#171A1B',
  'neutral-100': '#080A0B',
  'warning-05': '#FFF9EF',
  'warning-10': '#FFEDD1',
  'warning-20': '#FFD28F',
  'warning-30': '#F3912F',
  'warning-40': '#BA5D00',
  'warning-50': '#934B03',
  'warning-100': '#43280E',
  'error-05': '#FBF2F2',
  'error-10': '#F7E7E7',
  'error-20': '#FF9696',
  'error-30': '#FF5F5F',
  'error-40': '#D40000',
  'error-50': '#A90000',
  'success-05': '#F6F9F2',
  'success-10': '#E5F8DE',
  'success-20': '#84E399',
  'success-30': '#4AC966',
  'success-40': '#038A21',
  'success-50': '#006B18',
  'success-60': '#DFFCC4',
  'success-70': '#243915',
  'information-05': '#F6FCFF',
  'information-10': '#E1F4FF',
  'information-20': '#8AE6FF',
  'information-30': '#4DC1FD',
  'information-40': '#0077C4',
  'information-50': '#005987',
  'information-dark': '#0C8FAA',
  'brand-1': '#FF730B',
  'brand-2': '#FF8F0F',
  'brand-3': '#FFCEA8',
  'consumer-blue': '#0066CC',
  'dark-consumer-blue': '#51A8FF',
  'api-get': '#005FD6',
  'api-patch': '#00A0A7',
  'api-post': '#00764B',
  'api-put': '#ED5500',
  'api-delete': '#B3352A',
  'api-pub': '#005FD6',
  'api-sub': '#00764B',
  'api-get-dark': '#61AAFF',
  'api-patch-dark': '#00DAE3',
  'api-post-dark': '#00D285',
  'api-put-dark': '#FF843F',
  'api-delete-dark': '#FF8379',
  'api-pub-dark': '#005FD6',
  'api-sub-dark': '#00764B',
  'attention': '#FFBD5C',
}